import { createSlice } from '@reduxjs/toolkit'


export const SCREEN_REDUCER_KEY = 'screenPage'

const SCREENS = [
    '00-SelectLang',

    '01-video-hello',
    '02-game-labyrinth',
    '03-video-labyrinth-done',
    '04-map-01',

    '05-video-map',
    '06-game-puzzle',
    '07-map-02',

    '08-video-100-years-before',
    '09-game-shadow',
    '10-map-03',

    '11-video-klyaksus',
    '12-game-kamaz',
    '13-map-04',

    '14-video-geography-city',
    '15-game-paint',
    '16-map-05',

    '17-video-staruy',
    '18-game-double',
    '19-map-0607',

    '20-video-geography-nature',
    '21-game-animals',
    '22-map-08',

    '23-video-win',
]

const screenSlice = createSlice({
    name: SCREEN_REDUCER_KEY,
    initialState: {
        currentScreen: null,
        nextScreen: null,

        readyTriggerScreenOnReady: false,

        resources: [],
    },
    reducers: {
        goNextScreen: (state, { payload = {} }) => {
            const { restart } = payload
            let index

            if (restart) {
                index = 0
            } else {
                index = SCREENS.indexOf(state.currentScreen)
                index = (index === -1 || (index + 1 === SCREENS.length)) ? 0 : index + 1
            }

            state.nextScreen = SCREENS[index]

            state.readyTriggerScreenOnReady = false

            state.resources = []
        },

        setReadyTriggerScreenOnReady: (state) => {
            state.readyTriggerScreenOnReady = true

            tryTriggerScreen(state)
        },

        registerResource: (state, { payload }) => {
            if (state.resources.length || !state.readyTriggerScreenOnReady) {
                state.resources.push(payload)
            }
        },
        resolveResource: (state, { payload }) => {
            const index = state.resources.indexOf(payload)

            if (index >= 0) {
                state.resources.splice(index, 1)

                tryTriggerScreen(state)
            }
        },
    },
})

function tryTriggerScreen(state) {
    if (state.readyTriggerScreenOnReady && state.resources.length === 0) {
        state.currentScreen = state.nextScreen
        state.nextScreen = null
    }
}

export const {
    goNextScreen,
    restartGame,
    setReadyTriggerScreenOnReady,
    dropOldResources,
    registerResource,
    resolveResource,
} = screenSlice.actions

const getState = state => state[SCREEN_REDUCER_KEY]
export const getCurrentScreen = state => getState(state).currentScreen
export const getNextScreen = state => getState(state).nextScreen
export const getIsBorderVisible = state => Boolean(getState(state).nextScreen) || !getState(state).currentScreen
export const getIsResourcesReady = state => getState(state).resources.length === 0

export default screenSlice.reducer
